import { createTheme } from "@mui/material";
import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";
import { themeBase } from "./_themeBase";

export const CustomTheme = createTheme(themeBase, {
  palette: {
    primary: {
      main: "#5D5BDB",
      dark: "#5D5D5D",
      light: "#E9AEF9",
    },
    secondary: {
      main: "#F2704F",
    },
    backgroundRight: {
      main: "#5D5BDB",
      dark: "#5D5D5D",
      light: "#E9AEF9",
      tab: "#E8E8FA",
    },
    phoneInput: {
      main: "#E8E8FA",
    },
    otherColors: {
      main: "#FFFFFF",
      backgroundsColors: "#5D5D5D",
      tabText: "#FFFFFF",
      tabBackground: "#5D5BDB",
      menuIcon: "#5D5BDB",
    },
    barProgress: {
      main: "#5D5BDB",
    },
    marketPlace: {
      main: "#FFFFFF",
      cardBackground: "#C2E5F3",
    },
    cotizador: {
      backgroundColor: "#E8E8FA",
      barColor: "#B094FF",
      iconColor: "#5D5BDB",
      markLabelColor: "#5D5BDB",
    },
    buttonSelected: {
      backgroundColor: "#E9AEF9",
      backgroundColorActive: "#5D5BDB",
      textColor: "#000",
      textColorActive: "#FFFFFF",
      bordeColorActive: "#E8E8FA",
    },
    screenBackground: {
      backgroundColor: "#E8E8FA",
      textColor: "#5D5BDB",
      subTextColor: "#000000",
      iconColor: "#5D5BDB",

      backgroundColorBofu: "#E8E8FA",
      textColorBofu: "#5D5BDB",
      subTextColorBofu: "#000000",
      iconColorBofu: "#5D5BDB",
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
          },
          "& .MuiFilledInput-root": {
            borderRadius: "10px",
          },
          "& .MuiInputBase-root": {
            borderRadius: "10px",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E9AEF9",
          },
          "& .MuiInput-underline::before": {
            borderColor: "#E9AEF9",
          },
          "& .MuiFilledInput-underline::before": {
            borderColor: "#E9AEF9",
          },
          "& .MuiInputLabel-asterisk": {
            color: "#CD0202",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          padding: "10px 25px",
          textTransform: "none",
          fontSize: 16,
          fontWeight: 700,
        },
      },
      variants: [
        {
          props: {
            variant: "default",
          },
          style: {
            backgroundColor: "#5D5BDB",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#5D5BDB",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#5D5D5D",
              color: "#E9AEF9",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
        {
          props: {
            variant: "default_disabled",
          },
          style: {
            backgroundColor: "#5D5BDB",
            opacity: 0.4,
            color: "#FFF",
            // "&.Mui-disabled": {
            //   backgroundColor: "#528CD6",
            //   opacity: 0.4,
            //   color: "#FFF",
            // },
            "&:hover": {
              backgroundColor: "#5D5BDB",
              color: "#FFF",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },

        {
          props: {
            variant: "contained",
          },
          style: {
            "&.Mui-disabled": {
              backgroundColor: "#5D5BDB",
              opacity: 0.4,
              color: "#FFF",
            },
          },
        },
        {
          props: {
            variant: "orange",
          },
          style: {
            backgroundColor: "#F2704F",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#F2704F",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#F2704F",
            },
          },
        },
        {
          props: {
            variant: "black",
          },
          style: {
            backgroundColor: "#2C2C2C",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#2C2C2C",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#2C2C2C",
            },
          },
        },
        {
          props: {
            variant: "blue_outlined",
          },
          style: {
            color: "#5D5D5D",
            backgroundColor: "#FFF",
            border: "2px solid #5D5D5D",
            lineHeight: "22px",
            "&.Mui-disabled": {
              color: "#bdbdbd",
              border: "2px solid #bdbdbd",
              backgroundColor: "transparent",
            },
            "&.MuiButton-blue_outlinedSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
        {
          props: {
            variant: "blue_demon",
          },
          style: {
            // color: "#E9AEF9",
            color: "#FFFFFF",
            backgroundColor: "#5D5D5D",
            "&.Mui-disabled": {
              color: "#FFFFFF",
              backgroundColor: "#5D5D5D",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#5D5D5D",
            },
          },
        },
        {
          props: {
            variant: "green",
          },
          style: {
            color: "#FFFFFF",
            backgroundColor: "#00BB2D",
            "&.Mui-disabled": {
              backgroundColor: "#009A24",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#009A24",
            },
          },
        },
        {
          props: {
            variant: "expediente_validado",
          },
          style: {
            width: "150px",
            height: "30px",
            fontSize: 15,
            color: "#5D5BDB",
            backgroundColor: "#E9AEF9",
            "&.Mui-disabled": {
              backgroundColor: "#E9AEF9",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#E9AEF9",
            },
          },
        },
        {
          props: {
            variant: "expediente_validado",
            size: "small",
          },
          style: {
            width: "90px",
            height: "23px",
            fontSize: 13,
          },
        },
        {
          props: {
            variant: "expediente",
          },
          style: {
            paddingLeft: "10px",
            paddingRight: "10px",
            width: "150px",
            height: "30px",
            fontSize: 15,
            backgroundColor: "#5D5BDB",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#5D5BDB",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#5D5D5D",
              color: "#E9AEF9",
            },
          },
        },
        {
          props: {
            variant: "expediente",
            size: "small",
          },
          style: {
            width: "90px",
            height: "23px",
            fontSize: 13,
          },
        },
        {
          props: {
            variant: "yellow",
          },
          style: {
            backgroundColor: "#FF9D14",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#FF9D14",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#FF9D14",
              color: "#FFF",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
      ],
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          "& .MuiInputLabel-asterisk": {
            color: "#CD0202",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#E9AEF9", // Borde azul cuando no está enfocado
              borderRadius: "4px",
            },
            "&:hover fieldset": {
              borderColor: "#E9AEF9", // Borde azul al pasar el cursor
            },
            "&.Mui-focused fieldset": {
              borderColor: "#E9AEF9", // Borde azul cuando está enfocado
            },
          },
          "& .MuiSelect-icon": {
            color: "#E9AEF9", // Color del icono de selección
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          // "& .MuiSelect-icon": {
          //   color: "#E9AEF9",
          // },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E9AEF9",
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          color: "#5D5D5D",
        },
      },
    },
  },
});

export const interfaceConfig: InterfaceConfig = {
  name: "finbra",
  home_url: "/solicita_tu_credito",
  aviso_privacidad: "/aviso_de_privacidad",
  terminos_condiciones: "/terminos_y_condiciones",
  interest_rate: 36,
  metadata: {
    title: "Finbra",
    description:
      "Finbra es una plataforma de crédito para PyMEs que ofrece créditos especializados para PyMEs con tasas competitivas y procesos ágiles. Obtén el financiamiento que tu empresa necesita para crecer.",
    favicon: "finbra/portal/logos/favicon.ico",
  },
  navbar: {
    logo: "finbra/portal/logos/logo_navbar.png",
    logo_width: 142,
    logo_height: 28.5,
  },
  lateral: {
    logo_light: "finbra/portal/logos/logo_light_bg.png",
    bg_light: CustomTheme.palette.primary.light,
    text_light: "#FFFFFF",
    logo_dark: "finbra/portal/logos/logo_dark_bg.png",
    bg_dark: CustomTheme.palette.primary.main,
    text_dark: "#FFFFFF",
    image_list: [
      "finbra/portal/lateral/imagen_1.webp",
      "finbra/portal/lateral/imagen_2.webp",
      "finbra/portal/lateral/imagen_3.webp",
      "finbra/portal/lateral/imagen_4.webp",
      "finbra/portal/lateral/imagen_5.webp",
      "finbra/portal/lateral/imagen_6.webp",
      "finbra/portal/lateral/imagen_7.webp",
      "finbra/portal/lateral/imagen_8.webp",
      "finbra/portal/lateral/imagen_9.webp",
      "finbra/portal/lateral/imagen_10.webp",
    ],
    text_list: [
      "Multiplica el potencial de tu empresa",
      "Garantía simple, financiamiento ágil",
      "Obtén capital rápido, seguro y confiable",
      "La fuerza de tu patrimonio, ahora en crédito",
      "Crece sin límites, respáldate con Finbra",
      "Soluciones inteligentes, respaldo sólido",
      "El respaldo que da tranquilidad a tu crecimiento",
      "Tu garantía, nuestro impulso financiero",
      "Capital seguro, procesos simples",
      "Crédito sólido, futuro seguro",
    ],
  },
  textos_tofu: {
    pm: {
      crear_cuenta: {
        titulo: "Te damos la bienvenida",
        sub_titulo: "",
      },
      registro_datos_personales: {
        titulo: "Creación de cuenta",
        sub_titulo: "",
      },
      validacion_telefono: {
        titulo: "Validación de teléfono",
        sub_titulo: "",
      },
      datos_empresa_pm: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      consulta_ciec: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      uso_de_credito: {
        titulo: "Selección de uso de crédito",
        sub_titulo: "",
      },
      presencia_digital_pm: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
      datos_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo:
          "En caso de tener más de un accionista en igualdad de acciones,\ningresar al que además funja como Representante Legal",
      },
      rfc_curp: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      domicilio_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      consulta_buro_nip: {
        titulo: "Validación para consulta buró",
        sub_titulo: "",
      },
      buro_bloqueado: {
        titulo: "Consulta de Buró de Crédito del Accionista Bloqueada",
        sub_titulo: "",
      },
    },
    pfae: {
      datos_empresa_pfae: {
        titulo: "Registro de empresa",
        sub_titulo: "Ingresa los datos de la persona física con actividad empresarial",
      },
      consulta_buro_pfae: {
        titulo: "Consulta Buró",
        sub_titulo: "",
      },
      domicilio_pfae: {
        titulo: "Domicilio",
        sub_titulo: "",
      },
      presencia_digital_pfae: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
    },
  },
  cotizador: {
    estimated_amount_text:
      "*Esta simulación es para fines demostrativos y está sujeto \na aprobación, las condiciones como la tasa, el monto del \ncrédito, o la comisión por apertura, podrían cambiar \ndependiendo el perfil y la situación actual del solicitante.",
    has_quotation_table: true,
  },
  maps: {
    api_key:
      import.meta.env.VITE_ENV === "PROD"
        ? "AIzaSyDAtCLTqWu3XTjTC6AT2ZysdXUtL33bAX4"
        : "AIzaSyAPkyPkzcAbvKAageB8UN25PKbzl4stiWc",
  },
  companyNames: ["Litore Avances SAPI de CV SOFOM ENR", "Lendit Group SAPI de CV"],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud.",
  firma: {
    provider: "mifiel",
    condiciones_credito: {
      monto: true,
      plazo: true,
      tasa: false,
    },
    habilitar_calendario_pagos: true,
    habilitar_tabla_amortizacion: true,
  },
  formularios: {
    informacion_bancaria_empresa: {
      numero_estados_cuenta: 6,
    },
    informacion_bancaria_aval: {
      numero_estados_cuenta: 6,
    },
    informacion_bancaria_pfae: {
      numero_estados_cuenta: 6,
    },
    informacion_bancaria_segundo_aval: {
      numero_estados_cuenta: 6,
    },
  },
  scripts: {
    tag_id_hotjar: "6487602",
    tag_id_google: "",
    tag_id_linkedin: "",
    tag_id_meta_pixel: "",
  },
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_8zojFhirb",
      userPoolClientId: "6nb99vcp0t5odvfe8otkfj3eg5",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_VMSIpROPX",
      userPoolClientId: "3qg6411ka995m7le4t8gdi95bm",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
